import { onBeforeUnmount, type Ref } from 'vue'
import { QMenu } from 'quasar'
import { handleScroll } from './handleScroll'
import { ScrollManager } from './ScrollManager'
import { type UseHandleScroll } from './types/UseHandleScroll'

export const useHandleScrollQMenu = (
  qMenu: Ref<QMenu>,
  scrollTarget: HTMLElement,
): UseHandleScroll => {
  const handler = (scroller: EventTarget | null): void => {
    if (!qMenu.value || !(scrollTarget instanceof HTMLElement)) {
      return
    }

    if (scroller instanceof Element && scroller.classList.contains('q-menu')) {
      // ignore scroll events from the menu itself (otherwise this can cause event loops in some browsers)
      return
    }

    handleScroll(scrollTarget, qMenu.value?.updatePosition, qMenu.value?.hide)
  }

  const subscribe = (): void => ScrollManager.getInstance().subscribe(handler)
  const unsubscribe = (): void => ScrollManager.getInstance().unsubscribe(handler)

  onBeforeUnmount(unsubscribe)

  return {
    subscribe,
    unsubscribe,
  }
}
